<template>
    <div>
        <div class="content-header row align-items-center">
            <div class="content-header-left col-md-6 col-12 mb-1">
                <h3 class="content-header-title mb-0">Ratings & Reviews</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Ratings & Reviews
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-1 d-flex align-items-center justify-content-md-end">
                <download-excel type="csv" :data="formattedData" :name="'Review and Rating.csv'"
                                :sheet-name="'Report'">
                    <a href="#" class="export-link">
                        <i class="fas fa-file-csv"></i> Export to CSV
                    </a>
                </download-excel>
                <span class="mx-1">|</span>
                <download-excel :data="formattedData" :name="'Review and Rating.xls'">
                    <a href="#" class="export-link text-warning">
                        <i class="fa fa-file-excel-o"></i> Export to Excel
                    </a>
                </download-excel>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body py-1">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allRatings"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                             <span v-else-if="props.column.field === 'order_id'">
                                <a v-if="props.row.order_id" :href="route('admin.orders.show', props.row.order_id)">
                                    {{ props.row.order_number || props.row.order_id }}
                                </a>
                                <span v-else>—</span>
                             </span>
                             <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                             </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Ratings & Reviews'},
    props: [
        'ratings',
    ],
    layout: Layout,
    components: {
        Link,
    },
    mixins: [
        PaginationMixin,
    ],
    data() {
        return {
            filter: {},
            isLoadingFilter: false,
            allRatings: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer Email', field: 'user.email', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Customer Phone', field: 'user.phone', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Customer First Name',
                    field: 'user.first_name',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {label: 'Customer Last Name', field: 'user.last_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Order', field: 'order_id', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Rating',
                    field: 'rating',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn,
                },
                {label: 'Review', field: 'review', thClass: 'text-center', tdClass: 'text-center'},
            ],
            tableDataLoading: false,
            saving: false,
            isEditing: false,
            excelData: {},
        }
    },

    mounted() {
        this.allRatings = this.ratings.data;
        this.excelData = this.allRatings;
        this.totalRecords = this.ratings.total;
    },

    methods: {
        formatFn: function (value) {
            switch (value) {
                case 1:
                    return "Very Bad";
                case 2:
                    return "Bad";
                case 3:
                    return "Good";
                case 4:
                    return "Very Good";
                case 5:
                    return "Awesome";
                default:
                    return ""; // Handle the case when value is not 1-5.
            }
        },
        async paginatedData() {
            try {
                let routeName = 'admin.customers.ratings.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allRatings = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
    },
    computed: {
        formattedData() {
            const rows = [];

            // Create a row for column headers
            rows.push(['Customer Email', 'Customer Phone', 'Customer First Name', 'Customer Last Name', 'Order', 'Rating', 'Review']);

            // Add rows for each key-value pair in reportData
            for (const key in this.excelData) {
                const row = {
                    customer_email: this.excelData[key].user.email,
                    customer_phone: this.excelData[key].user.phone,
                    customer_first_name: this.excelData[key].user.first_name,
                    customer_last_name: this.excelData[key].user.last_name,
                    rating: this.formatFn(this.excelData[key].rating),
                    review: this.excelData[key].review,
                };
                console.log(row);

                rows.push([this.excelData[key].user.email,
                    this.excelData[key].user.phone,
                    this.excelData[key].user.first_name,
                    this.excelData[key].user.last_name,
                    this.excelData[key].order_number || this.excelData[key].order_id || '',
                    this.formatFn(this.excelData[key].rating),
                    this.excelData[key].review,
                ]);
            }

            return rows;
        }
    }
}
</script>
